import SEOMeta from '@/components/feature/SEOMeta';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import CategoriesSection from './components/CategoriesSection';
import PopularContent from './components/PopularContent';
import BenefitsSection from './components/BenefitsSection';
import TestimonialsSection from './components/TestimonialsSection';
import CTASection from './components/CTASection';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'asmrone',
  url: 'https://asmrone.com',
  description: 'asmrone 是专为 ASMR 爱好者打造的沉浸式音频体验平台，提供海量高品质 ASMR 内容，帮助深度放松、缓解焦虑、改善睡眠质量。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://asmrone.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <>
      <SEOMeta
        title="首页"
        description="asmrone 是专为 ASMR 爱好者打造的沉浸式音频体验平台，提供海量高品质 ASMR 内容，包括耳语、自然音效、角色扮演等多元场景，帮助用户深度放松、缓解焦虑、改善睡眠质量。立即探索 asmrone，开启属于你的专属解压音频世界。"
        keywords="asmrone,asmrone官网,asmrone音频平台,ASMR沉浸体验,ASMR助眠音频,ASMR解压放松"
        canonicalUrl="https://asmrone.com"
        schema={homeSchema}
      />

      <main>
        <HeroSection />
        <FeaturesSection />
        <CategoriesSection />
        <PopularContent />
        <BenefitsSection />
        <TestimonialsSection />
        <CTASection />
      </main>
    </>
  );
}